import { Vector3 } from 'three'

export type CommentOrientation = 'horizontal' | 'vertical'

export const commentOrientations: CommentOrientation[] = ['horizontal', 'vertical']

export const DEFAULT_COMMENT_ORIENTATION: CommentOrientation = 'horizontal'

/** Fallback for comments persisted before the orientation field existed. */
export const FALLBACK_COMMENT_ORIENTATION: CommentOrientation = 'horizontal'

export const commentOrientationLabels: Record<CommentOrientation, string> = {
  horizontal: 'Horizontal',
  vertical: 'Vertikal',
}

/**
 * The persisted comment orientation, falling back to horizontal for legacy
 * comments that predate the field.
 */
export const getCommentOrientation = (
  comment: Pick<Comment3D, 'orientation'>,
): CommentOrientation => comment.orientation ?? FALLBACK_COMMENT_ORIENTATION

/** Text basis vectors for Text3DThree (vertical = 90° counter-clockwise). */
export const getCommentTextOrientations = (
  orientation: CommentOrientation,
): { textXOrientation: Vector3; textYOrientation: Vector3 } => {
  if (orientation === 'vertical') {
    return {
      textXOrientation: new Vector3(0, 1, 0),
      textYOrientation: new Vector3(-1, 0, 0),
    }
  }
  return {
    textXOrientation: new Vector3(1, 0, 0),
    textYOrientation: new Vector3(0, 1, 0),
  }
}

export const toggleCommentOrientation = (orientation: CommentOrientation): CommentOrientation =>
  orientation === 'horizontal' ? 'vertical' : 'horizontal'
